export default __webpack_public_path__ + "static/media/arrow-right-blue.b9da6181.svg";